{
  "info": "Información",
  "negative": "Error",
  "notice": "Advertencia",
  "positive": "Éxito"
}
